enum languageCodes {
  arabic = 'ar',
  english = 'en',
  ENGLISH_KENYA = 'en_ken',
}

const getDropdownLanguagesList = () => [
  {
    langCode: languageCodes.arabic,
    langValue: 'Arabic',
  },
  {
    langCode: languageCodes.english,
    langValue: 'English',
  },
];

let DefaultLanguage = 'ar';


const changeDefaultLanguage = (langCode: languageCodes) => {
  DefaultLanguage = langCode;
};

export {
  DefaultLanguage, changeDefaultLanguage, getDropdownLanguagesList, languageCodes,
};
